// Base URL of the backend API
export const BASE_URL = process.env.REACT_APP_BACKEND_URL ; // Update with your actual backend URL

// Endpoints Object
export const ENDPOINTS = {
  loginAdmin: '/api/v1/admin/login',
  getAllCourse: '/api/v1/course/getAllCourseForAdmin',
  getCourseById: '/api/v1/course/getSingleCourse',
  updateCourseById: '/api/v1/course/updateCourse',
  uploadExcelForCourse: '/api/v1/course/uploadExcelForCourse',
  getUnitDetails: '/api/v1/unit/details',
  createLevel: '/api/v1/level/createLevel',
  updateLevel: '/api/v1/level/updateLevelForAdmin',
  archiveLevel: '/api/v1/level/archiveLevel',
  restoreArchivedLevelById: '/api/v1/level/restoreArchivedLevelById',
  createQuestionsForLevel: `/api/v1/question/createQuestionsForLevel`,
  createUnitWithLevelsAndQuestions: `/api/v1/unit/createUnitWithLevelsAndQuestions`,
  createCourseDraft: `/api/v1/course/createCourseDraft`,
  getAllUviForAdmin: `/api/v1/question/getAllUviForAdmin`,
  getAIReviewedUVIQuestions: `/api/v1/question/getAIReviewedUVIQuestions`,
  reviewQuestion: `/api/v1/question/reviewQuestion`,
  archiveLevelQuestions: `/api/v1/question/archiveQuestionsForLevel`,
  restoreLevelQuestions: `/api/v1/question/restoreQuestionsForLevel`,
  reorderLevelQuestions: `/api/v1/question/reorderQuestionsForLevel`,
  linkAudioForCourse:   `/api/v1/course/linkAudioForCourse`,
  updateAudioFileForQuestion: `/api/v1/course/updateAudioFileForQuestion`,
  uploadFlag: `/api/v1/course/uploadFlag`,
  markCoursePublish: `/api/v1/course/markCoursePublish`,
  updateCourseStatus: `/api/v1/course/updateCourseStatus`,
  getUserSubscriptionForAdmin: `/api/v1/subscription/getUserSubscriptionForAdmin`,
  deleteCourse: `/api/v1/course/deleteCourse`,
  getAllUpgradedLARForAdmin: `/api/v1/question/getAllUpgradedLARForAdmin`,
  setTargetAccent: `/api/v1/ai/setTargetAccent`,
  getAiModels: `/api/v1/ai/getAiModels`,
  getAllReviewVoiceNotesForAdmin: `/api/v1/question/getAllReviewVoiceNotesForAdmin`,
  getAllReviewUpgradedLARForAdmin: `/api/v1/question/getAllReviewUpgradedLARForAdmin`,
};
